import {
  IconArrowDown,
  IconArrowsSort,
  IconArrowUp,
} from '@tabler/icons-react';
import { memo } from 'react';
import { SortConfig } from '../../utils/types';

interface ColumnHeaderProps {
  label: string;
  columnKey: string;
  sortKey: string;
  onToggleColumn?: (key: string) => void;
  locked?: boolean;
  onSort?: (key: string) => void;
  sort?: SortConfig;
  noSort?: boolean;
  enableManageColumn?: boolean;
}

const ColumnHeader = memo(
  ({ label, columnKey, sortKey, onSort, sort, noSort = false }: ColumnHeaderProps) => {
    const handleSort = () => {
      onSort?.(sortKey || columnKey);
    };

    const renderSortIcon = () => {
      if (sort?.column == (sortKey || columnKey)) {
        return sort.direction === 'asc' ? (
          <IconArrowUp size={14} height={15} className="text-blue" />
        ) : (
          <IconArrowDown size={14} height={15} className="text-blue" />
        );
      }
      return <IconArrowsSort size={14} height={15} />;
    };

    return (
      <>
        {label}
        {!noSort && (
          <span role="button" className="ms-1" onClick={handleSort}>
            {renderSortIcon()}
          </span>
        )}
      </>
    );
  },
);

ColumnHeader.displayName = 'ColumnHeader';

export default ColumnHeader;
